// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"9f8dceca","453":"a6a97343"}[chunkId] + ".chunk.js";
};